// Client-side preview of the scoring rule (mirrors backend for instant feedback).
// Weights: turnover 25 + float 20 + rvol 15 + gap 15 + range 10 + news 10 + mcap 5 = 100.
const NEWS_POINTS = {
  earnings: 8, major_contract: 9, ma: 10, fda: 10,
  fundraising: -5, dilution: -8, none: 0,
};

// Volume relatif — 15 pts (rescaled)
function tierRvol(r) {
  if (r == null) return 0;
  if (r >= 20) return 15;
  if (r >= 10) return 12;
  if (r >= 5) return 9;
  if (r >= 2) return 5;
  return 0;
}
// Flottant — 20 pts
function tierFloat(s) {
  if (s == null) return 0;
  const m = s / 1e6;
  if (m < 10) return 20;
  if (m < 20) return 15;
  if (m < 50) return 10;
  if (m < 100) return 5;
  return 0;
}
// Gap — 15 pts (unchanged)
function tierGap(g) {
  if (g == null) return 0;
  if (g >= 30) return 15; if (g >= 20) return 12; if (g >= 10) return 9;
  if (g >= 5) return 6; if (g >= 2) return 3; return 0;
}
// Range — 10 pts (unchanged)
function tierRange(p) {
  if (p == null) return 0;
  if (p >= 80) return 10; if (p >= 60) return 8; if (p >= 40) return 5;
  if (p >= 20) return 3; return 1;
}
// Capitalisation — 5 pts (rescaled)
function tierMcap(m) {
  if (m == null) return 0;
  const v = m / 1e6;
  if (v < 20) return 5;
  if (v < 50) return 4;
  if (v < 100) return 3;
  if (v < 500) return 1.5;
  return 0;
}
// Rotation — 25 pts (main criterion)
function tierTurnover(t) {
  if (t == null) return 0;
  if (t >= 5000) return 25;
  if (t >= 1500) return 20;
  if (t >= 500) return 15;
  if (t >= 100) return 8;
  return 0;
}

export function computeRvol(vol, avg) {
  if (vol == null || avg == null || avg <= 0) return null;
  return vol / avg;
}
export function computeGap(open, prev) {
  if (open == null || prev == null || prev <= 0) return null;
  return ((open - prev) / prev) * 100;
}

export function previewScore(criteria) {
  const rvol = computeRvol(criteria.volume, criteria.avg_volume_3m);
  const gap = computeGap(criteria.open_price, criteria.prev_close);
  const breakdown = {
    rvol: { value: rvol, points: tierRvol(rvol), max: 15, label: "Volume relatif" },
    float: { value: criteria.shares_outstanding, points: tierFloat(criteria.shares_outstanding), max: 20, label: "Flottant" },
    gap: { value: gap, points: tierGap(gap), max: 15, label: "Gap d'ouverture" },
    range: { value: criteria.pct_range, points: tierRange(criteria.pct_range), max: 10, label: "Position fourchette" },
    market_cap: { value: criteria.market_cap, points: tierMcap(criteria.market_cap), max: 5, label: "Capitalisation" },
    turnover: { value: criteria.pct_turnover, points: tierTurnover(criteria.pct_turnover), max: 25, label: "Rotation flottant" },
    news: { value: criteria.news_category || "none", points: NEWS_POINTS[criteria.news_category || "none"] ?? 0, max: 10, label: "Nouvelles" },
  };
  const total = Math.max(0, Math.min(100, Math.round(Object.values(breakdown).reduce((a, b) => a + b.points, 0))));
  return { total, breakdown };
}

export function decisionFromScore(s) {
  if (s >= 80) return { code: "fonce", label: "Fonce", color: "fonce" };
  if (s >= 60) return { code: "investis", label: "Investis", color: "investis" };
  return { code: "ignore", label: "Ignore", color: "ignore" };
}
